module.exports = __webpack_public_path__ + "img/mevius-wind-blue.ec170e6d.jpg";